import type { Profile, UserBody } from './types';

import { apiClient } from '~shared/api';

export const getProfile = (group: string): Promise<Profile> =>
  apiClient.get<Profile>(`/api/${group}/profile`, { groupId: group });

export const updateProfile = (
  group: string,
  profile: UserBody
): Promise<void> =>
  apiClient.put<void>(`/api/${group}/profile`, profile, { groupId: group });
